// @ts-nocheck
import React from 'react'

const INITIAL_CONTEXT = {
  isDisabled: false,
  isOpen: false,
}

export const AccordionContext = React.createContext(INITIAL_CONTEXT)
